module.exports = __webpack_public_path__ + "img/low_stock_products.24ff2670.svg";